export const websiteUrl = 'https://st6.io/';
export const githubUrl = 'https://github.com/st6io/meme';
